"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _prettyData = require("pretty-data");

var _toPolylines2 = _interopRequireDefault(require("./toPolylines"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var polylineToPath = function polylineToPath(rgb, polyline) {
  var color24bit = rgb[2] | rgb[1] << 8 | rgb[0] << 16;
  var prepad = color24bit.toString(16);

  for (var i = 0, il = 6 - prepad.length; i < il; ++i) {
    prepad = '0' + prepad;
  }

  var hex = '#' + prepad; // SVG is white by default, so make white lines black

  if (hex === '#ffffff') {
    hex = '#000000';
  }

  var d = polyline.reduce(function (acc, point, i) {
    acc += i === 0 ? 'M' : 'L';
    acc += point[0] + ',' + point[1];
    return acc;
  }, '');
  return '<path fill="none" stroke="' + hex + '" stroke-width="0.1%" d="' + d + '"/>';
};
/**
 * Convert the interpolate polylines to SVG
 */


var _default = function _default(parsed) {
  var _toPolylines = (0, _toPolylines2.default)(parsed),
      bbox = _toPolylines.bbox,
      polylines = _toPolylines.polylines;

  var paths = polylines.map(function (polyline, i) {
    var vertices = polyline.vertices.map(function (v) {
      return [v[0], -v[1]];
    });
    return polylineToPath(polyline.rgb, vertices);
  }); // If the DXF is empty the bounding box will have +-Infinity values,
  // so clamp values to zero in this case

  var viewBox = bbox.min.x === Infinity ? {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  } : {
    x: bbox.min.x,
    y: -bbox.max.y,
    width: bbox.max.x - bbox.min.x,
    height: bbox.max.y - bbox.min.y
  };
  var svgString = "\n<?xml version=\"1.0\"?>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\"\n    preserveAspectRatio=\"xMinYMin meet\"\n    viewBox=\"".concat(viewBox.x, " ").concat(viewBox.y, " ").concat(viewBox.width, " ").concat(viewBox.height, "\"\n    width=\"100%\"\n    height=\"100%\"\n  >\n    ").concat(paths.join('\n'), "\n</svg>");
  return _prettyData.pd.xml(svgString);
};

exports.default = _default;